(() => {
  const finders = document.querySelectorAll('[data-ak-fit-finder]');

  finders.forEach((finder) => {
    const steps = Array.from(finder.querySelectorAll('[data-ak-fit-step]'));
    const resultsPanel = finder.querySelector('[data-ak-fit-results]');
    const progress = finder.querySelector('[data-ak-fit-progress]');
    const resultList = finder.querySelector('[data-ak-result-list]');
    const resultIntro = finder.querySelector('[data-ak-result-intro]');
    const next = finder.querySelector('[data-ak-next]');
    const back = finder.querySelector('[data-ak-back]');
    const restart = finder.querySelector('[data-ak-restart]');
    const answers = {};
    let current = 0;

    const products = {
      coche: {
        name: 'Coche XL',
        detail: 'Up to 110 lb. Light, compact, and easy to load for everyday travel.',
        handle: 'coche-xl-lightweight-special-needs-stroller-transport-chair',
        maxCapacity: 110,
      },
      maclaren: {
        name: 'Maclaren Major Elite',
        detail: 'Up to 110 lb. A simple daily chair for school, errands, and appointments.',
        handle: 'maclaren-major-elite',
        maxCapacity: 110,
      },
      freedom: {
        name: 'Advance Mobility Freedom',
        detail: 'Up to 200 lb. All-terrain mobility for active family days.',
        handle: 'advance-mobility-freedom-push-chair-navy-1',
        maxCapacity: 200,
      },
      lassen: {
        name: 'Axiom Lassen',
        detail: '150, 200, or 250 lb by selected size. Swivel-front indoor/outdoor control.',
        handle: 'adaptive-star-axiom-lassen-indoor-outdoor-mobility-push-chair',
        maxCapacity: 250,
      },
      improv: {
        name: 'Axiom Improv',
        detail: '150 or 200 lb by selected size. Fixed-front-wheel tracking for rougher routes.',
        handle: 'adaptive-star-axiom-improv-mobility-push-chair',
        maxCapacity: 200,
      },
      endeavour: {
        name: 'Axiom Endeavour',
        detail: '150, 200, or 250 lb by selected size. Large wheels for long outdoor days.',
        handle: 'adaptive-star-axiom-endeavour-indoor-outdoor-mobility-push-chair',
        maxCapacity: 250,
      },
    };

    const capacityMinimums = {
      'under-110': 110,
      '111-150': 150,
      '151-200': 200,
      '201-250': 250,
    };

    const selectedValue = (step) =>
      step.querySelector('.ak-fit-option.is-selected')?.dataset.value || '';

    const showStep = (index) => {
      current = index;
      steps.forEach((step, stepIndex) => {
        step.hidden = stepIndex !== current;
      });
      resultsPanel.hidden = true;
      progress.style.width = `${((current + 1) / steps.length) * 100}%`;
      back.hidden = current === 0;
      next.textContent = current === steps.length - 1 ? 'See my best matches' : 'Next';
      next.disabled = !selectedValue(steps[current]);
    };

    const rankedKeys = () => {
      const terrain = answers.terrain;
      const priority = answers.priority;

      if (terrain === 'trail') {
        return priority === 'turning'
          ? ['freedom', 'lassen', 'improv', 'endeavour', 'coche', 'maclaren']
          : ['improv', 'freedom', 'endeavour', 'lassen', 'coche', 'maclaren'];
      }
      if (terrain === 'travel' || priority === 'lightweight') {
        return ['coche', 'maclaren', 'lassen', 'improv', 'freedom', 'endeavour'];
      }
      if (priority === 'capacity') {
        return ['lassen', 'endeavour', 'freedom', 'improv', 'coche', 'maclaren'];
      }
      if (terrain === 'mixed') {
        return ['lassen', 'freedom', 'improv', 'endeavour', 'maclaren', 'coche'];
      }
      return ['maclaren', 'coche', 'lassen', 'freedom', 'improv', 'endeavour'];
    };

    const chooseMatches = () => {
      const minimumCapacity = capacityMinimums[answers.capacity];
      if (!minimumCapacity) return [];

      return rankedKeys()
        .map((key) => products[key])
        .filter((product) => product.maxCapacity >= minimumCapacity)
        .slice(0, 2);
    };

    const appendResult = ({ href, name, detail, action }) => {
      const card = document.createElement('a');
      card.className = 'ak-fit-result';
      card.href = href;

      const nameNode = document.createElement('strong');
      nameNode.textContent = name;
      const detailNode = document.createElement('span');
      detailNode.textContent = detail;
      const actionNode = document.createElement('span');
      actionNode.textContent = action;

      card.append(nameNode, detailNode, actionNode);
      resultList.append(card);
    };

    const renderResults = () => {
      resultList.replaceChildren();

      if (answers.capacity === 'unsure') {
        resultIntro.textContent = 'Capacity has to be confirmed before we recommend a chair. Send us the rider\'s weight and seated measurements for a human starting point.';
        appendResult({
          href: 'tel:18004225439',
          name: 'Call an Adaptive Kidz fit specialist',
          detail: 'Have the rider\'s weight and seated measurements handy. We will help narrow the product options.',
          action: 'Call 800-422-5439 \u2192',
        });
        appendResult({
          href: '/collections/adaptive-push-chairs',
          name: 'Compare every adaptive chair',
          detail: 'Review capacity, seat dimensions, fold, terrain, and available sizes across the full collection.',
          action: 'Open the chair comparison \u2192',
        });
      } else {
        resultIntro.textContent = 'Every result below has a published size with capacity covering the full range you selected. Confirm exact size and seated measurements before ordering.';
        chooseMatches().forEach((product) => {
          appendResult({
            href: `/products/${product.handle}`,
            name: product.name,
            detail: product.detail,
            action: 'View chair, size, and fit \u2192',
          });
        });
      }

      steps.forEach((step) => {
        step.hidden = true;
      });
      resultsPanel.hidden = false;
      next.hidden = true;
      back.hidden = true;
      progress.style.width = '100%';
      resultsPanel.querySelector('h2')?.focus();
    };

    finder.addEventListener('click', (event) => {
      const option = event.target.closest('.ak-fit-option');
      if (option) {
        const step = option.closest('[data-ak-fit-step]');
        step.querySelectorAll('.ak-fit-option').forEach((button) => {
          button.classList.toggle('is-selected', button === option);
          button.setAttribute('aria-pressed', button === option ? 'true' : 'false');
        });
        next.disabled = false;
        return;
      }

      if (event.target.closest('[data-ak-next]')) {
        const step = steps[current];
        answers[step.dataset.question] = selectedValue(step);
        if (current === steps.length - 1) {
          renderResults();
        } else {
          showStep(current + 1);
        }
      }

      if (event.target.closest('[data-ak-back]')) {
        showStep(Math.max(0, current - 1));
      }

      if (event.target.closest('[data-ak-restart]')) {
        Object.keys(answers).forEach((key) => delete answers[key]);
        finder.querySelectorAll('.ak-fit-option').forEach((button) => {
          button.classList.remove('is-selected');
          button.setAttribute('aria-pressed', 'false');
        });
        next.hidden = false;
        showStep(0);
      }
    });

    showStep(0);
  });

  const contactProduct = new URLSearchParams(window.location.search).get('product');
  const contactContext = document.querySelector('[data-ak-contact-context]');
  const contactProductInput = document.querySelector('#ContactForm-product');
  if (contactProduct && contactContext && contactProductInput) {
    contactProductInput.value = contactProduct;
    const productName = contactContext.querySelector('[data-ak-contact-product-name]');
    if (productName) productName.textContent = contactProduct;
    contactContext.hidden = false;
  }

  const initSmartHeader = () => {
    const header = document.querySelector('.ak-site-header');
    if (!header || header.dataset.akSmartHeaderBound === 'true') return;

    header.dataset.akSmartHeaderBound = 'true';
    header.classList.add('ak-site-header--smart-ready');
    header.closest('.shopify-section')?.classList.add('ak-smart-header-host');

    const mobileNavigation = header.querySelector('.ak-mobile-nav');
    const activationPoint = 250;
    const minimumDelta = 6;
    const hideDistance = 18;
    const showDistance = 56;
    let lastScroll = Math.max(0, window.scrollY || 0);
    let directionAnchor = lastScroll;
    let isHidden = false;
    let frameRequested = false;
    let keyboardNavigation = false;

    const currentScroll = () => Math.max(0, window.scrollY || 0);
    const navigationIsActive = () => Boolean(
      mobileNavigation?.open || (keyboardNavigation && header.contains(document.activeElement))
    );

    const setHidden = (shouldHide) => {
      const nextHidden = Boolean(shouldHide && !navigationIsActive());
      if (nextHidden === isHidden) return;

      isHidden = nextHidden;
      header.classList.toggle('ak-site-header--smart-hidden', isHidden);
    };

    const resetDirection = () => {
      const scrollPosition = currentScroll();
      lastScroll = scrollPosition;
      directionAnchor = scrollPosition;
      header.classList.toggle('ak-site-header--smart-active', scrollPosition > activationPoint);
      if (scrollPosition <= activationPoint || navigationIsActive()) setHidden(false);
    };

    const updateHeader = () => {
      frameRequested = false;

      const scrollPosition = currentScroll();
      const scrollDelta = scrollPosition - lastScroll;
      header.classList.toggle('ak-site-header--smart-active', scrollPosition > activationPoint);

      if (scrollPosition <= activationPoint || navigationIsActive()) {
        setHidden(false);
        lastScroll = scrollPosition;
        directionAnchor = scrollPosition;
        return;
      }

      if (Math.abs(scrollDelta) < minimumDelta) return;

      if (scrollDelta > 0) {
        if (isHidden) {
          directionAnchor = Math.max(directionAnchor, scrollPosition);
        } else if (scrollPosition - directionAnchor >= hideDistance) {
          directionAnchor = scrollPosition;
          setHidden(true);
        }
      } else if (!isHidden) {
        directionAnchor = scrollPosition;
      } else if (directionAnchor - scrollPosition >= showDistance) {
        directionAnchor = scrollPosition;
        setHidden(false);
      }

      lastScroll = scrollPosition;
    };

    const requestUpdate = () => {
      if (frameRequested) return;
      frameRequested = true;
      window.requestAnimationFrame(updateHeader);
    };

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', resetDirection, { passive: true });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Tab') keyboardNavigation = true;
    }, true);
    document.addEventListener('pointerdown', () => {
      keyboardNavigation = false;
    }, true);
    mobileNavigation?.addEventListener('toggle', resetDirection);
    header.addEventListener('focusin', resetDirection);

    resetDirection();
  };

  const initMobileConversionDock = () => {
    const dock = document.querySelector('[data-ak-mobile-conversion-dock]');
    if (!dock || dock.dataset.akDockBound === 'true') return;

    dock.dataset.akDockBound = 'true';
    const buyZone = document.querySelector(dock.dataset.akBuyZone || '');
    const mobileViewport = window.matchMedia('(max-width: 749px)');
    let buyZoneVisible = false;
    let frameRequested = false;

    const updateDock = () => {
      frameRequested = false;
      const shouldShow = mobileViewport.matches && window.scrollY > 180 && !buyZoneVisible;
      dock.classList.toggle('is-visible', shouldShow);
      dock.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      dock.toggleAttribute('inert', !shouldShow);
    };

    const requestDockUpdate = () => {
      if (frameRequested) return;
      frameRequested = true;
      window.requestAnimationFrame(updateDock);
    };

    if (buyZone && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        buyZoneVisible = entries.some((entry) => entry.isIntersecting && entry.intersectionRatio > 0.15);
        requestDockUpdate();
      }, { threshold: [0, 0.15, 0.5] });
      observer.observe(buyZone);
    }

    window.addEventListener('scroll', requestDockUpdate, { passive: true });
    window.addEventListener('resize', requestDockUpdate, { passive: true });
    mobileViewport.addEventListener?.('change', requestDockUpdate);
    updateDock();
  };

  const initPhoneClickTracking = () => {
    document.addEventListener('click', (event) => {
      const phoneLink = event.target.closest('a[href^="tel:18004225439"]');
      if (!phoneLink) return;

      const detail = {
        phone_number: '800-422-5439',
        placement: phoneLink.dataset.akPhoneLocation || 'storefront',
        page_path: window.location.pathname,
      };

      if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push({ event: 'adaptive_kidz_phone_click', ...detail });
      }
      document.dispatchEvent(new CustomEvent('adaptive-kidz:phone-click', { detail }));
    });
  };

  initSmartHeader();
  initMobileConversionDock();
  initPhoneClickTracking();
})();
